/**
 * Chat Image Settings - Aspect ratio and resolution chips
 */

import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/v2/ui';

interface Props {
  aspectRatio: string;
  resolution: string;
  onAspectRatioChange: (value: string) => void;
  onResolutionChange: (value: string) => void;
}

const ASPECT_RATIOS = ['1:1', '4:3', '3:4', '16:9', '9:16', '4:5', '5:4', '2:3', '3:2', '21:9', '1:4', '4:1', '1:8', '8:1'];
const RESOLUTIONS = ['0.5K', '1K', '2K', '4K'];

export function ChatImageSettings({ aspectRatio, resolution, onAspectRatioChange, onResolutionChange }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-2 text-xs">
      <span className="text-neutral-500 dark:text-neutral-400">{t('chatImage.aspectRatio')}:</span>
      {ASPECT_RATIOS.map((ratio) => (
        <button key={ratio} onClick={() => onAspectRatioChange(ratio)}>
          <Badge variant={aspectRatio === ratio ? 'primary' : 'default'} size="sm">
            {ratio}
          </Badge>
        </button>
      ))}
      <span className="ml-2 text-neutral-500 dark:text-neutral-400">{t('chatImage.resolution')}:</span>
      {RESOLUTIONS.map((res) => (
        <button key={res} onClick={() => onResolutionChange(res)}>
          <Badge variant={resolution === res ? 'primary' : 'default'} size="sm">
            {res}
          </Badge>
        </button>
      ))}
    </div>
  );
}
